// ------------------------------------
// Constants
// ------------------------------------
export const INCREMENT_LOADER_STATUS = 'INCREMENT_LOADER_STATUS'
export const DECREMENT_LOADER_STATUS = 'DECREMENT_LOADER_STATUS'

// ------------------------------------
// Actions
// ------------------------------------
export const incrementLoaderStatus = () => {
  return {
    type: INCREMENT_LOADER_STATUS,
    payload: 1
  }
}

export const decrementtLoaderStatus = () => {
  return {
    type: DECREMENT_LOADER_STATUS,
    payload: 1
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [INCREMENT_LOADER_STATUS]: (state, action) => ++state,
  [DECREMENT_LOADER_STATUS]: (state, action) => --state
}

// ------------------------------------
// Reducer
// ------------------------------------
export function generalLoaderReducer (state = 0, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/generalLoader.js